import { render, staticRenderFns } from "./editSeckillAct.vue?vue&type=template&id=42e1d271&scoped=true&"
import script from "./editSeckillAct.vue?vue&type=script&lang=js&"
export * from "./editSeckillAct.vue?vue&type=script&lang=js&"
import style0 from "./editSeckillAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editSeckillAct.vue?vue&type=style&index=1&id=42e1d271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1d271",
  null
  
)

component.options.__file = "editSeckillAct.vue"
export default component.exports